import isArray from './isArray';
import stringToPath from './_stringToPath';

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

export default castPath;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_castPath.js
// module id = null
// module chunks = 